import React from 'react';
import 'contents/assets/scss/page/mypage.scss';
import Paging from '../../component/Inc/Paging';
import Upload from '../../component/Inc/Upload';
import BtnLike from "../../component/Inc/BtnLike";//좋아요 버튼
function Papers() {

  return (
    <main className="com_container p_papers">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu9_2'>회사 문서 양식</h2>
          <button onClick={() => {}} className="com_btn orange s btn_plus">회사양식 등록</button>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <section className='com_board_search end'>
                <article className='search'>
                  <input type="search" placeholder='검색할 내용을 입력해 주세요.' className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="6%"/><col width="10%"/>
               <col /><col width="10%"/>
                <col width="10%"/><col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>등록일</th>
                  <th>제목</th>
                  <th>파일</th>
                  <th>등록자</th>
                  <th>조회</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <BtnLike/>
                  </td>
                  <td className='td_date'>2022.08.25</td>
                  <td>수2자격증 기안서양식.</td>
                  <td><button className="btn_link blue">다운로드</button></td>
                  <td>홍길동103</td>
                  <td>34</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td className='td_date'>2022.08.25</td>
                      <td>수2자격증 기안서양식.</td>
                      <td><button className="btn_link blue">다운로드</button></td>
                      <td>홍길동103</td>
                      <td>34</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          {/* 상세보기 */}
          <section className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot" />
              <p className="date">2023.05.20 11:30</p>
              <div className="count"><p>조회 <span className="cnt">321</span></p></div>
            </div>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <div className="com_btn_wrap">
                  <BtnLike/>
                  <button className="btn_edit"></button>
                  <button className="btn_delete"></button>
                </div>
              </div>
              <div className="sec_input">
                <input type="text" className="input" placeholder='물품청구서 양식' />
              </div>
              <div className="editor">
                인사총무팀에서 공유 드립니다.<br/><br/>

                물품 청구서 양식입니다.<br/>
                감사합니다.
              </div>
              <div className="com_input_upload">
                <Upload title="파일 등록" className="com_btn gray s wl" />
                <p className="file">
                  <span className="txt">File name.pdf</span>
                  <button
                    type="button"
                    className="btn_del_file"
                    onClick={() => {}}
                  ></button>
                  <button
                    type="button"
                    className="btn_down"
                    onClick={() => {}}
                  ></button>
                </p>
              </div>
            </div>
          </section>
        </section>
      </div>
    </main>
  );
}

export default Papers;
